import React from "react";
import { zip } from "lodash-es";

import KLink from "@kikoff/components/src/v1/navigation/KLink";
import { combineClasses } from "@kikoff/utils/src/string";

type AgreementTextProps = {
  className?: string;

  size: "small" | "mini";
  beforeActions?: React.ReactNode;
  children?: React.ReactNode;
  after?: React.ReactNode;
} & ({ byClicking: string } | { by: string });

export default function AgreementText({
  className,
  beforeActions,
  size,
  children,
  after,
  ...props
}: AgreementTextProps) {
  let keyCounter = 0;
  const b = (text) => (
    <span className="text:+" key={keyCounter++}>
      {text}
    </span>
  );

  const childArray = React.Children.toArray(children).filter(Boolean).map(b);

  const hasItems = childArray.length !== 0;

  if (!beforeActions && !hasItems) return null;

  const list = zip(
    childArray.map(b),
    childArray.length > 1 &&
      Array.from({ length: childArray.length - 2 }, () => ", ").concat(" and ")
  ).flat();

  return (
    <div className={combineClasses(`text:${size}`, className)}>
      By {"by" in props ? b(props.by) : <>clicking {b(props.byClicking)}</>},{" "}
      {beforeActions && (
        <>
          {beforeActions}
          {hasItems ? " and " : ""}
        </>
      )}
      {hasItems && <>you agree to our {list}</>}
      {after}.
    </div>
  );
}

type DocLinkProps<T extends KLink.Type> =
  | KLink.Props<T>
  | (Partial<KLink.Props<T>> & { onClick: KLink.Props<T>["onClick"] });

export function DocLink<T extends KLink.Type>({
  href,
  variant = "underlined",
  onClick,
  children,
  ...props
}: DocLinkProps<T>) {
  return (
    <KLink
      href={href || "#"}
      newTab
      variant={variant}
      onClick={
        onClick
          ? (e) => {
              if (!href) e.preventDefault();
              onClick(e);
            }
          : null
      }
      {...props}
    >
      {children}
    </KLink>
  );
}
